import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchRules, updateSelectedRules, addOrderedRules } from 'redux/rules/RulesActions';
import RulesSelector from './RulesSelector';

const mapStateToProps = state => ({
  rules: state.rules.rules,
  totalEntries: state.rules.pageState.totalEntries,
  fetchingRules: state.rules.fetchingRules,
  selectedRules: state.rules.selectedRules,
  orderedRules: state.rules.orderedRules
});

const mapDispatchToProps = dispatch => ({
  rulesActions: bindActionCreators({ fetchRules, updateSelectedRules, addOrderedRules }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RulesSelector);




// WEBPACK FOOTER //
// ./src/components/importProfile/comp/rulesPanel/comp/profileRulesManagement/comp/rulesSelector/RulesSelectorConnector.js